// extracted by mini-css-extract-plugin
module.exports = {"content":"create-task_content__2vB1f"};